import { array, boolean, InferType, number, object, string } from 'yup';

const surveyDataQuestionScheme = object({
  uuid: string().required(),
  title: string().required(),
  type: string().required(),
  required: boolean(),
}).required();

const getSurveyDataScheme = object({
  id: number().required(),
  title: string().required(),
  description: string().required(),
  questions: array(surveyDataQuestionScheme).required(),
  createdAt: string().required(),
  startedAt: string().required(),
  schemeTypes: array(string()).required(),
}).nullable();

export type GetSurveyDataType = InferType<typeof getSurveyDataScheme>;
export type SurveyDataQuestionType = InferType<typeof surveyDataQuestionScheme>;

export default getSurveyDataScheme;
